export function nav($, bootstrap) {
    initHamburger($);
	initPrimaryNav($, bootstrap);

    $('#primary-search-link').click(function(e) {
        e.preventDefault();
        $('#primary-search-field').focus();
    });

}

function initHamburger($) {
	// prevent internal collapse triggering the parent
	$('#primaryNavigation .collapse').on('show.bs.collapse hide.bs.collapse shown.bs.collapse hidden.bs.collapse', function( event ) {
		event.stopPropagation();
	});

	$('#collapseInnerB').on('hide.bs.collapse', function( event ) {
		event.stopPropagation();
	})

	$('#primaryNavigation').on('show.bs.collapse', function(event) {
		$('body:not(.microsite)').addClass('nav-open');
		fixTertiaryHeight($);
	});

	$('#primaryNavigation').on('shown.bs.collapse', function(event) {
		fixTertiaryHeight($);
	});

	$('#primaryNavigation .multi-collapse').on('shown.bs.collapse', function(event) {
		fixTertiaryHeight($);
		$('body').addClass('nav-open');
		$('#primaryNavigation').addClass('show');
		$('.hamburger-menu')
			.removeClass('collapsed')
			.attr('aria-expanded', true);
	});

	$('#primaryNavigation .multi-collapse').on('hide.bs.collapse', function(event) {
		removeTertiaryHeight($);
	});

	$('#primaryNavigation').on('hide.bs.collapse', function(event) {
		$('body:not(.microsite)').removeClass('nav-open');

		$('.dropdown_toggle', this).attr('aria-expanded', false);
		$('.multi-collapse', this).removeClass('show');
	});
}


function initPrimaryNav($, bootstrap) {
	// nav activation
	let $nav = $('#primaryNavigation');

	// initially show open state
	var parent = $('.dropdown-item.active:eq(0)', $nav).parents('.dropdown-menu');
    var parent_id = parent.attr('aria-labelledby');
    var parent_link = $("#" + parent_id);
    // show.click();
    parent_link.addClass('show');
    parent.addClass('show');
    parent_link.attr('aria-expanded', true);

    // fix height overflow with tertiary menu
	$('.dropdown-item', $nav).on('click', function(event) {
		fixTertiaryHeight($);
	});
}

function removeTertiaryHeight($) {
	let $nav = $('#primaryNavigation .multi-collapse');
	$nav.css('min-height', 0);
}

function fixTertiaryHeight($) {
	let $nav = $('#primaryNavigation .multi-collapse');
	var $active = $('.dropdown-menu.show', $nav);
	$nav.css('min-height', 0);

	if( $active.length ) {
		var height = $active.height();
		$nav.css('min-height', `calc(${height}px + 4rem + 50px)`);
	}
}